"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var react = require('react');
var n = require('styled-components');
var reactTabs = require('@radix-ui/react-tabs');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var n__default = /*#__PURE__*/_interopDefaultLegacy(n);

var W=`
    --tabs-hover-background: var(--color-neutral-100);
    --tabs-active-hover-background: var(--color-blurple-100);

  [data-theme='dark'] & {
    --tabs-hover-background: var(--color-neutral-700);
    --tabs-active-hover-background: var(--color-blurple-900);
  }
`,v=n.css`
  padding: 0 var(--spacing-large);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`,b=n__default["default"].div`
  ${v};
`,d=n__default["default"](reactTabs.Trigger)`
  all: unset;
  cursor: pointer;
  color: var(--foreground-secondary);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-bold);
  text-align: center;
  transition: color 0.2s ease-in, background 0.2s ease-in;
  white-space: nowrap;
  min-height: 46px;
  padding: var(--border-width-small);
  display: flex;
  justify-content: center;
  align-items: center;

  ${({asChild:t})=>t&&n.css`
      > * {
        all: unset;
        ${v};
      }
    `}

  ${chunkPBLNC4OF_js.b} {
    font-size: var(--icon-size-regular);
    margin-right: var(--spacing-small);
  }

  &:hover {
    color: var(--foreground-link-active);
    background: var(--tabs-hover-background);
    box-shadow: inset 0 -1px 0 0 var(--border-default),
      0 1px 0 0 var(--border-default);
  }

  &:focus-visible {
    color: var(--border-link-focus);
    background: var(--tabs-hover-background);

    ${b} {
      outline: var(--border-width-small) solid var(--border-link-focus);
      border-radius: 4px;
    }
  }

  &[data-state='active'] {
    color: var(--foreground-link-active);

    &:hover {
      background: var(--tabs-active-hover-background);
    }

    &:focus {
      background: var(--tabs-active-hover-background);
    }
  }
`,T=n__default["default"].div`
  z-index: 1;
  position: absolute;
  left: 0;
  bottom: -1px;
  height: 2px;
  background: var(--foreground-link-active);
  transition: left 0.4s cubic-bezier(0.33, 0.14, 0.13, 0.97);
`,m=n__default["default"](reactTabs.List)`
  border-bottom: 1px solid var(--border-default);
  display: flex;
  position: relative;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }

  [data-theme='light'] & {
    background-image: 
      /* Shadows */ linear-gradient(
        to right,
        white,
        white
      ),
      linear-gradient(to right, white, white),
      /* Shadow covers */
        linear-gradient(to right, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0)),
      linear-gradient(to left, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0));

    background-position: left center, right center, left center, right center;
    background-repeat: no-repeat;
    background-color: white;
    background-size: 40px 100%, 40px 100%, 20px 100%, 20px 100%;

    /* Opera doesn't support this in the shorthand */
    background-attachment: local, local, scroll, scroll;
  }
`,A=n.css`
  ${d} {
    font-size: var(--font-size-small);
    padding: var(--spacing-small);

    ${chunkPBLNC4OF_js.b} {
      font-size: var(--icon-size-small);
    }
  }
`,F=n.css`
  ${m} {
    justify-content: center;
  }
`,D=n.css`
  ${d} {
    flex: 1;
  }
`,x=n__default["default"](reactTabs.Root).attrs({activationMode:"manual"})`
  ${W}

  ${({$size:t})=>t==="small"&&A}

  ${({$align:t})=>t==="center"&&F}
  ${({$align:t})=>t==="stretch"&&D}
`,C=n__default["default"](reactTabs.Content)``;var V=({children:t,...o})=>{let r=react.useRef(null),[a,g]=react.useState({width:0,left:0}),s=()=>{var p,h;let e=(p=r.current)==null?void 0:p.querySelector("[data-state=active]"),i=(h=e==null?void 0:e.parentElement)==null?void 0:h.getBoundingClientRect(),{width:u,left:f}=(e==null?void 0:e.getBoundingClientRect())||{width:0,left:0};g({width:u,left:f-((i==null?void 0:i.left)||0)});};react.useEffect(()=>{let e=r.current,i=new MutationObserver(f=>{f.forEach(p=>{p.type==="childList"&&requestAnimationFrame(s);});}),u={childList:!0,subtree:!0};return e&&i.observe(e,u),()=>{i.disconnect();}},[]);let $=()=>{s();};return react.useLayoutEffect(()=>(s(),window.addEventListener("resize",s),()=>{window.removeEventListener("resize",s);}),[]),jsxRuntime.jsxs(m,{ref:r,onClick:$,...o,children:[t,jsxRuntime.jsx(T,{style:a})]})},L=n__default["default"](V)``;var J=({icon:t,value:o,children:r,...a})=>jsxRuntime.jsx(d,{value:o,...a,children:jsxRuntime.jsxs(b,{children:[t&&jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:t}),r]})}),w=n__default["default"](J)``;var U=({defaultValue:t,size:o,align:r,children:a,...g})=>jsxRuntime.jsx(x,{$size:o,$align:r,defaultValue:t,...g,children:a}),y=n__default["default"](U)``;var Z=({value:t,children:o,...r})=>jsxRuntime.jsx(C,{value:t,...r,children:o}),P=n__default["default"](Z)``;var j={Root:y,List:L,Trigger:w,Content:P};

exports.a = j;
